<div v-if="shouldRenderConfig" v-bind:class="getClassName" v-show="!getForceDisablePersonalization">
    <div v-if="getWebProductEnableTemplateChooser">
        <Select2
            v-model="value"
            :options="options"
            :settings="settings"
        />        
    </div>
    <button type="button" class="btn btn-primary" ref="personalizeBtn" v-bind:class="getDisableClass" v-on:click="onClickPersonalize()">
        {{ $t('Personalize') }}
    </button>    
</div>

